// import 'promise-polyfill';
// import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import './style/bootstrap/bootstrap.less';
import './style';


require("babel-polyfill");


let root;
function init() {
	window.__APP_CONFIG__ = JSON.parse(atob(window.__INIT__()));
	let App = require('./components/app').default;
	ReactDOM.render(<App />, document.getElementById('app-body'));
}

// register ServiceWorker via OfflinePlugin, for prod only:
if (process.env.NODE_ENV === 'production') {
	require('./pwa');
}

// in development, set up HMR:
if (module.hot) {
	//require('preact/devtools');   // turn this on if you want to enable React DevTools!
	module.hot.accept('./components/app', () => requestAnimationFrame(init));
}

init();



// WEBPACK FOOTER //
// ./index.js